import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import CNETAccordion from '../../components/CNETAccordion/CNETAccordion'
import ReviewsContainer from '../../components/Reviews/ReviewsContainer'
import QandAContainer from '../../components/QandA/QandAContainer'
import GenericAccordion from '../../components/GenericAccordion/GenericAccordion'
import NutritionSection from '../../components/NutritionSection/NutritionSection'
import HabitatDimensionsSection from '../../components/HabitatDimensions/HabitatDimensionSection'
import EnergyLabelAccordion from '../../components/EnergyLabels/EnergyLabelAccordion'
import { BrandContextConsumer } from '../../providers/BrandConfigContext/BrandConfigContext'
import Delivery from '../../components/MadeToOrderComponents/DeliveryAndReturns/DeliveryAndReturnsAccordion'
import MeasureBeforeYouOrder from '../../components/MadeToOrderComponents/MeasureBeforeYouOrder/MeasureBeforeYouOrderAccordion'

class AccordionsSection extends Component {
  render() {
    const {
      className,
      cnetOptions,
      reviewsOptions,
      qAndAOptions,
      genericAccordionOptions,
      nutrition,
      habitatDimensionOptions,
      energyLabelOptions,
      FREQUENTY_BROUHT_TOGETHER,
      hasDeliveryAccordion,
      isMTO,
      hasMeasureBeforeYouOrderAccordion
    } = this.props

    const isNutritionContent = nutrition?.nutritionInformation?.nutritionData.length > 0
    const isDimensionsContent = habitatDimensionOptions?.dimensions?.attributes.size
    const isEnergyLabel = imgUrl =>
      imgUrl.trim().substring(imgUrl.length - 4) === 'A001' || imgUrl.trim().substring(imgUrl.length - 4) === 'A002'
    const energyLabelContent = energyLabelOptions?.images?.filter(isEnergyLabel)
    const attributes = energyLabelOptions?.attributes
    const energyOptions = {
      onAccordionChange: energyLabelOptions?.onAccordionChange,
      energyLabelContent,
      attributes
    }

    return (
      <section className={className}>
        {(isDimensionsContent || isMTO) && (
          <ErrorBoundary>
            <HabitatDimensionsSection {...habitatDimensionOptions} isMTO={isMTO} />
          </ErrorBoundary>
        )}
        {hasMeasureBeforeYouOrderAccordion && (
          <ErrorBoundary>
            <MeasureBeforeYouOrder />
          </ErrorBoundary>
        )}
        {hasDeliveryAccordion && (
          <ErrorBoundary>
            <Delivery />
          </ErrorBoundary>
        )}
        {isNutritionContent && (
          <ErrorBoundary>
            <NutritionSection data-test='nutrition-section' {...nutrition} />
          </ErrorBoundary>
        )}
        {energyLabelContent?.length > 0 && (
          <ErrorBoundary>
            <EnergyLabelAccordion {...energyOptions} />
          </ErrorBoundary>
        )}
        {cnetOptions.isCNETContent && (
          <ErrorBoundary>
            <CNETAccordion {...cnetOptions} />
          </ErrorBoundary>
        )}
        <ErrorBoundary>
          <BrandContextConsumer>
            <ReviewsContainer {...reviewsOptions} isMadeToOrder={isMTO} />
          </BrandContextConsumer>
        </ErrorBoundary>
        <ErrorBoundary>
          <QandAContainer {...qAndAOptions} isMadeToOrder={isMTO} />
        </ErrorBoundary>
        <ErrorBoundary>
          <GenericAccordion {...genericAccordionOptions} type='offers' />
        </ErrorBoundary>
        <ErrorBoundary>
          {FREQUENTY_BROUHT_TOGETHER && <GenericAccordion {...genericAccordionOptions} type='bundles' />}
        </ErrorBoundary>
      </section>
    )
  }
}

AccordionsSection.propTypes = {
  className: PropTypes.string.isRequired,
  cnetOptions: PropTypes.object.isRequired,
  reviewsOptions: PropTypes.object.isRequired,
  qAndAOptions: PropTypes.object.isRequired,
  genericAccordionOptions: PropTypes.object.isRequired,
  nutrition: PropTypes.object,
  habitatDimensionOptions: PropTypes.object,
  hasDeliveryAccordion: PropTypes.bool,
  isMTO: PropTypes.bool,
  hasMeasureBeforeYouOrderAccordion: PropTypes.bool,
  measureBeforeYouOrderContent: PropTypes.object,
  deliveryContent: PropTypes.object
}

AccordionsSection.defaultProps = {
  nutrition: {},
  isMTO: false
}

export default AccordionsSection
